import React from 'react';
import { Switch, HashRouter as Router } from 'react-router-dom';
import { connect } from 'react-redux';

import './assets/scss/theme.scss';

import Environment from './environment/Environment';

import { authProtectedRoutes } from './routes/Routes';
import AppRoute from './routes/AppRoute';

import Layout from './components/Layout/Layout';
import { DashboardCardData } from './api-services/filters.api';
import { GetPlanId } from './helpers/Helpers';

interface Props {
}

interface State {
  dashboardList: {
    tab: string;
    cards: {
      title: string;
      time?: string;
      location?: string;
      productHierarchy?: string;
      totalSeasons?: any;
      activePreSeasons?: any;
      targetPreSeasons?: any;
      quarters?: string;
      path: string;
    }[];
  }[];
}

class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      dashboardList: [],
    };
  }

  componentDidMount() {
    this.getDashboardCardData();
  }

  getDashboardCardData(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
    };

    DashboardCardData(params)
      .then((res) => {
        if (!!res) {
          this.setState({
            dashboardList: res.dashboardList,
          }, () => {
            this.dataInit();
          });
        }
      });
  }

  dataInit(): void {
    const list = this.state.dashboardList.map((data: any) => {
      return data.cards.map((card) => {
        return {
          path: card.path,
          planId: card.planId
        };
      });
    });
    sessionStorage.setItem(Environment.PROJECT + 'plan', JSON.stringify([].concat(...list)));
  }

  render() {
    return (
      <React.Fragment>
        <Router>
          <Switch>
            {
              authProtectedRoutes.map((route: any, idx: number) => (
                <AppRoute
                  key={idx}
                  path={route.path}
                  layout={Layout}
                  component={route.component}
                  children={route?.children || []}
                  isAuthProtected={true}
                />
              ))
            }
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    layout: state.Layout
  };
};

export default connect(mapStateToProps, null)(App);
